import React from 'react';
import ScheduleView from '../ScheduleViews';

export const ScheduleBoardOffline = ({ isActiveFavorites, onEpisodeClick, checkAuth, onRateEpisode, currentUser }) => {
    return (
        <ScheduleView
            isActiveFavorites={isActiveFavorites}
            onEpisodeClick={onEpisodeClick}
            checkAuth={checkAuth}
            onRateEpisode={onRateEpisode}
            currentUser={currentUser}
        />
    )
};
